
<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="study-editor.germplasm-checks.add.new.entries">Add New Entries</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="dismiss()">
    </button>
</div>
<div class="modal-body">
    <div class="row form-group mt-3">
        <div class="col-3">
			<label class="fw-bold"><span jhiTranslate="study-editor.germplasm-checks.entry.type">Entry Type:</span> </label> <span class='required'>*</span>
        </div>
        <div class="col-6">
            <ng-select [items]="entryTypes" [(ngModel)]="selectedEntryTypeId" bindValue="id" bindLabel="name" placeholder="{{'study-editor.germplasm-checks.entry.type.select' | translate}}">
                <ng-template ng-label-tmp let-item="item">
                    {{item.name}} - {{item.description}}
                </ng-template>
            </ng-select>
        </div>
    </div>
    <div class="row form-group mt-3" >
        <div class="col-3">
			<label class="fw-bold"><span jhiTranslate="study-editor.germplasm-checks.add.new.entries.gids">GIDs:</span> </label> <span class='required'>*</span>
        </div>
        <div class="col-7 d-flex align-items-center">
            <input class="form-control" type="text" [(ngModel)]="selectedGids" />
            <button class="btn btn-info ms-2" (click)="openSelectGermplasmForAddingEntries()" jhiTranslate="select">Select</button>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary" (click)="cancel()" jhiTranslate="cancel">Cancel</button>
    <button class="btn btn-primary" (click)="addNewEntries()" jhiTranslate="add">Add</button>
</div>

